import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

/**
 * StudyBreadcrumb — Breadcrumb de navegação para estudos
 *
 * Props:
 *   studyTitle — Título do estudo (exibido truncado)
 */
const StudyBreadcrumb = ({ studyTitle }) => (
  <div className="bg-white border-b border-gray-200 sticky top-0 z-30">
    <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3 text-sm">
        <Link
          to="/"
          className="flex items-center gap-1 text-gray-400 hover:text-gray-600 font-medium transition-colors"
        >
          <Home className="w-3.5 h-3.5" /> Início
        </Link>
        <span className="text-gray-300">/</span>
        <Link
          to="/estudos"
          className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
        >
          Estudos
        </Link>
        <span className="text-gray-300">/</span>
        <span className="text-gray-900 font-semibold truncate max-w-[200px]">
          {studyTitle}
        </span>
      </div>
    </div>
  </div>
);

export default StudyBreadcrumb;
